<script setup>
import {ref, onMounted, inject} from 'vue'
import axios from 'axios'
const sessions = ref([])

const props = defineProps({
    data: {
        type: Object,
        required: false,
    },
})

const contentData = inject('contentData')
const backEndURL = process.env.VUE_APP_BACKEND_URL
const getSessions = async url => {
    try {
        const res = await axios.get(`${backEndURL}/${url}`)
        sessions.value = res.data
    } catch (err) {
        console.error(err)
    }
}

onMounted(async () => {
    await getSessions('api/sessions')
})
const downloadPDF = () => {
    window.open('./assets/call2.pdf', '_blank')
}
</script>

<template>
    <div id="call_for_abstracts" class="py-16">
        <div class="max-w-3xl mx-auto text-center" v-if="contentData.what === 'rn'">
            <h1 class="font-heading text-3xl sm:text-4xl mt-2 mb-6 uppercase">CALL FOR ABSTRACTS</h1>
        </div>
        <section class="py-16 bg-gray-700 text-white" v-if="contentData.what === 'rn'">
            <div class="container px-4 mx-auto">
                <div class="max-w-3xl mx-auto mt-5">
                    <div class="text-lg leading-8 text-justify">
                        <div class="px-4 mx-auto" id="call">
                            <h1 class="font-heading text-3xl sm:text-4xl mb-6 uppercase">
                                Call for Abstracts and Nominations
                            </h1>
                            <p class="mb-5">
                                The Swiss National Science Foundation and the Swiss Reproducibility Network
                                invited to submit abstracts for the Swiss Reproducibility Conference, taking
                                place June, 10 - 11, 2024 in Zürich, as well as nominations for the Swiss
                                Reproducibility Award 2024.
                            </p>

                            <span class="text-sm font-semibold uppercase mt-10">
                                <b>Call for abstracts for contributed talks and posters</b>
                            </span>
                            <p>
                                Submissions for contributed talks and posters were welcome in all areas
                                related to the 3 session topics of the conference:
                            </p>
                            <ul class="list-disc ml-10">
                                <li
                                    v-for="session in sessions.filter(
                                        session =>
                                            !['Tutorials & Workshops', 'Other', 'Misc.', 'General'].includes(
                                                session.name
                                            )
                                    )"
                                    class="cursor-pointer text-cyan-700"
                                    :key="'abstract_' + ' ' + session.name">
                                    <a :href="`#${session.name}`">{{ session.name }}</a>
                                </li>
                            </ul>
                            <p>
                                The call has ended. Notifications of acceptance or rejection have been
                                communicated.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section
            class="my-8"
            v-else
            v-html="props.data.text.content"
            v-if="props.data.text.display"></section>
    </div>
</template>

<style scoped></style>
